export const Options = {
  BusinessOptions: [
    {
      id: 1,
      label: 'Adult'
    },
    {
      id: 2,
      label: 'Beauty & Cosmetics'
    },
    {
      id: 3,
      label: 'Bike'
    },
    {
      id: 4,
      label: 'Cafe & Food Truck'
    },
    {
      id: 6,
      label: 'CBD & Vape'
    },
    {
      id: 7,
      label: 'Electronics'
    },
    {
      id: 8,
      label: 'Fashion & Clothing'
    },
    {
      id: 9,
      label: 'Florist'
    },
    {
      id: 10,
      label: 'Footwear'
    },
    {
      id: 11,
      label: 'Furniture'
    },
    {
      id: 12,
      label: 'Gift Store'
    },
    {
      id: 13,
      label: 'Groceries & Food Retail'
    },
    {
      id: 14,
      label: 'Hair & Beauty Salon'
    },
    {
      id: 15,
      label: 'Health'
    },
    {
      id: 16,
      label: 'Homeware'
    },
    {
      id: 17,
      label: 'Jewellery'
    },
    {
      id: 18,
      label: 'Liquor Stores & Bottle Shop'
    },
    {
      id: 19,
      label: 'Pet'
    },
    {
      id: 20,
      label: 'Restaurant'
    },
    {
      id: 21,
      label: 'Second Hand Shop & Op Shop'
    },
    {
      id: 22,
      label: 'Services'
    },
    {
      id: 23,
      label: 'Sporting & Outdoor'
    },
    {
      id: 24,
      label: 'Sports Team'
    },
    {
      id: 25,
      label: 'Stadium & Events'
    },
    {
      id: 26,
      label: 'Tools & Hardware'
    },
    {
      id: 27,
      label: 'Tourism'
    },
    {
      id: 28,
      label: 'Toys, Hobbies & Crafts'
    },
    {
      id: 29,
      label: 'Other Retail'
    },
    {
      id: 30,
      label: 'Other Non-retail'
    },
    {
      id: 31,
      label: 'Adult'
    },
    {
      id: 32,
      label: 'Beauty & Cosmetics'
    },
    {
      id: 33,
      label: 'Bike'
    },
    {
      id: 36,
      label: 'CBD & Vape'
    },
    {
      id: 37,
      label: 'Electronics'
    },
    {
      id: 38,
      label: 'Fashion & Clothing'
    },
    {
      id: 39,
      label: 'Florist'
    },
    {
      id: 40,
      label: 'Footwear'
    },
    {
      id: 41,
      label: 'Furniture'
    },
    {
      id: 42,
      label: 'Gift Store'
    },
    {
      id: 43,
      label: 'Groceries & Food Retail'
    },
    {
      id: 44,
      label: 'Hair & Beauty Salon'
    },
    {
      id: 45,
      label: 'Health'
    },
    {
      id: 46,
      label: 'Homeware'
    },
    {
      id: 47,
      label: 'Jewellery'
    },
    {
      id: 48,
      label: 'Liquor Stores & Bottle Shop'
    },
    {
      id: 49,
      label: 'Pet'
    },
    {
      id: 50,
      label: 'Restaurant'
    },
    {
      id: 51,
      label: 'Second Hand Shop & Op Shop'
    },
    {
      id: 52,
      label: 'Services'
    },
    {
      id: 53,
      label: 'Sporting & Outdoor'
    },
    {
      id: 54,
      label: 'Sports Team'
    },
    {
      id: 55,
      label: 'Stadium & Events'
    },
    {
      id: 56,
      label: 'Tools & Hardware'
    },
    {
      id: 57,
      label: 'Tourism'
    },
    {
      id: 58,
      label: 'Toys, Hobbies & Crafts'
    },
    {
      id: 59,
      label: 'Other Retail'
    },
    {
      id: 60,
      label: 'Other Non-retail'
    }
  ],
  LocationOptions: [
    { Id: 1, label: '1 location' },
    { Id: 2, label: '2-9 locations' },
    { id: 3, label: '10+ locations' }
  ],
  TurnOverOptions: [
    { Id: 1, label: '$1k - $120k' },
    { Id: 2, label: '$120k - $360k' },
    { id: 3, label: '$360k - $600k' }
  ],
  CountriesOptions: [
    { Id: 1, label: 'Pakistan' },
    { Id: 2, label: 'Saudia' }
  ],
  CurrencyOptions: [
    { Id: 1, label: 'PKR' },
    { Id: 2, label: 'RIYAL' }
  ]
}

export const SALES_ORDER_STATUSES = [
  {
    SalesOrderStatuID: '1&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'LayBy',
    Name: '',
    IsActive: true,
    IsDisabled: true
  },
  {
    SalesOrderStatuID: '2&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'On Account',
    Name: '',
    IsActive: true,
    IsDisabled: true
  },
  {
    SalesOrderStatuID: '3&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'Parked',
    Name: '',
    IsActive: false,
    IsDisabled: true
  },
  {
    SalesOrderStatuID: '4&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'Delivery, unfulfilled',
    Name: '',
    IsActive: false,
    IsDisabled: true
  },
  {
    SalesOrderStatuID: '5&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'PickUp, unfulfilled',
    Name: '',
    IsActive: false,
    IsDisabled: true
  },
  {
    SalesOrderStatuID: '6&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'Completed',
    Name: '',
    IsActive: false,
    IsDisabled: true
  },
  {
    SalesOrderStatuID: '7&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'Layby, completed',
    Name: '',
    IsActive: false,
    IsDisabled: true
  },
  {
    SalesOrderStatuID: '8&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'On Account, completed',
    Name: '',
    IsActive: false,
    IsDisabled: true
  },
  {
    SalesOrderStatuID: '9&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'Delivery, completed',
    Name: '',
    IsActive: false,
    IsDisabled: true
  },
  {
    SalesOrderStatuID: '10&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'PickUp, completed',
    Name: '',
    IsActive: false,
    IsDisabled: true
  },
  {
    SalesOrderStatuID: '12&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'InProgress',
    Name: '',
    IsActive: false,
    IsDisabled: true
  },
  {
    SalesOrderStatuID: '13&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'Return, completed',
    Name: '',
    IsActive: false,
    IsDisabled: true
  },
  {
    SalesOrderStatuID: '11&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'Voided',
    Name: '',
    IsActive: false,
    IsDisabled: true
  },
  {
    SalesOrderStatuID: '14&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'Parked, return',
    Name: '',
    IsActive: false,
    IsDisabled: true
  },
  {
    SalesOrderStatuID: '15&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    StatusName: 'Return, In Progress',
    Name: '',
    IsActive: false,
    IsDisabled: true
  }
]

export const INHOUSE_PAYMENT_TYPE = [
  {
    StorePaymentTypeID: '2&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    sStorePaymentTypeID: '2&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    PaymentTypeName: 'Store Credit',
    GatewayName: 'storecredit',
    IsDisabled: true
  },
  {
    StorePaymentTypeID: '3&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    sStorePaymentTypeID: '3&&_9efa-1ea9-4faf-88ed-a48e65b46643',
    PaymentTypeName: 'Loyalty',
    GatewayName: 'loyalty',
    IsDisabled: true
  }
]

export const IN_HOUSE_PAY = {
  store_gateway: 'storecredit',
  loyalty_gateway: 'loyalty'
}

export const SALES_CHANNELS = {
  IN_STORE: 1,
  ONLINE: 2
}

export const STORE_CREDIT = {
  REDEMPTION: 'REDEMPTION',
  ISSUED: 'ISSUED'
}

export const SALE_ACTION_LOG = {
  ItemPriceAdjustment: '1',
  ItemDiscount: '2',
  SaleDiscount: '3',
  RemoveTax: '4'
}

export const SALE_TRACKING = [
  {
    ID: 1,
    // ID: "1&&_9efa-1ea9-4faf-88ed-a48e65b46643",
    NAME: 'PLACED'
  },
  {
    ID: 2,
    // ID: "2&&_9efa-1ea9-4faf-88ed-a48e12311126643",
    NAME: 'PREPARING'
  },
  {
    ID: 3,
    // ID: "3&&_9efa-1ea9-4faf-88ed-a48e65qq1231a43",
    NAME: 'READY'
  },
  {
    ID: 4,
    // ID: "4&&_9esfa-1ea22a9-4faf-88ed-a4aa8e65b46643",
    NAME: 'SERVED'
  },
  {
    ID: 5,
    // ID: "5&&_9a1effffa-1esa9-4faf-88ed-a4aaa118e65b46643",
    NAME: 'CANCEL'
  },
  {
    ID: 6,
    // ID: "6&&_922efa-1ea91-4faf1-88ed-a48e6aa5b46643",
    NAME: 'CHANGE'
  }
]

export const SALE_REG_REPORT_PRINT = {
  CURR_OPEN: 1,
  TODAY: 2,
  PAST_ONE: 3,
  PAST_TWO: 4
}

export const PRINTING_TYPE = [
  { id: 1, name: 'BlueTooth' },
  { id: 2, name: 'Wifi' }
]

export const PAYMENT_SOURCES_FOR_STORES = {
  cash: 1,
  apco: 2,
  paypal: 3,
  store_credit: 4,
  loyalty: 5,
  trustly: 6
}

export const PAY_PAY_MODE = {
  SUBSCRIPTION: 1,
  SALE: 2,
  REGISTRATION_SUBSCRIPTION: 3
}

export const PrintCheckOutlet = 'Show Outlet'
export const PrintCheckRegister = 'Show Register'
export const PrintCheckServedBy = 'Show Served By'
export const PrintCheckDatetime = 'Show Datetime'
export const PrintShowHeader = 'Show Header'
export const PrintShowFooter = 'Show Footer'
export const ShowPrinterProds = 'Show Only Printer Products'


export const PRINT_TYPES = {
  opening: 'opening_float',
  cashMove: 'cash_movement'
}

export const PRINT_CASH_MOVE_TYPES = {
  CASH_IN: 10,
  PETTY_CASH_IN: 11,
  CASH_OUT: 12,
  PETTY_CASH_OUT: 13
}

export const STORE_REQ_TYPES = {
  SUBSCRIPTION_REQ: 1,
  DEMO_VIDEO: 2
}

// export const REACT_APP_BUS_NAME = 'BUZZTILL POS'
// export const REACT_APP_BUS_FIRST_NAME = 'BUZZTILL'
// export const REACT_APP_BUS_SITE = 'https://www.buzztill.com' // 'https://www.dakarpos.com'
// export const REACT_APP_BUS_SITE_APP = 'https://app.buzztill.com' // 'https://app.dakarpos.com'
// export const REACT_APP_BUS_SITE_SECOND = '.buzztill.com' // '.dakarpos.com'
// export const REACT_APP_IDENTIFY_BUS_NAME = 'buzztill' // 'dakar'
// export const REACT_APP_PRINT_CONST_FOOTER_3 = `${REACT_APP_BUS_NAME} - www.buzztill.com`

export const IDENTIFY_BUS_NAME_LOCAL = 'local'
export const BUS_SITE_LOCAL = 'http://localhost:3000'
export const BUS_SITE_LOCAL_IP = 'http://192.168.18.8:3000'
export const BUS_PARENT_SITE = 'https://www.dakarsoftware.com'
export const PRINT_CONST_FOOTER_1 = 'Thank you for your support'
export const PRINT_CONST_FOOTER_2 = 'POS Provided and supported by'

export const NON_AUTH_PAGE_1 = `signin`
export const NON_AUTH_PAGE_2 = `signup`
export const NON_AUTH_PAGE_3 = `billing`
export const NON_AUTH_PAGE_4 = `store/request`
export const NON_AUTH_PAGE_5 = `loginstore`
export const NON_AUTH_PAGE_6 = `userverify`

export const non_auth_list = [
  NON_AUTH_PAGE_1,
  NON_AUTH_PAGE_2,
  NON_AUTH_PAGE_3,
  NON_AUTH_PAGE_4,
  NON_AUTH_PAGE_5,
  NON_AUTH_PAGE_6
]

export const PROD_DEFAULT_TAX = 0
export const SALE_DEFAULT_NO_TAX = 1

export const SYNC_STATUSES = {
  UNKNOWN: 0,
  SYNCED: 1,
  IN_PROGRESS: 2,
  ERROR: 3,
  PENDING: 4
}

export const OFFSET_SYNC_SALES = 5
export const OFFSET_SYNC_ERROR_SALES = 3
export const OFFSET_SYNC_PARKED_SALES = 3
export const SYNC_TIME_GAP = 5 * 60 * 1000 // 5 minutes

export const SYNC_CALL_TYPES = {
  CREATE: 1,
  PAY: 2,
  COMPLETE: 3
}

export const SellAttribGroupIcons = [
  {
    label: 'Table'
  },
  {
    label: 'Floor'
  },
  {
    label: 'OneTwoOne'
  },
  {
    label: 'Corners'
  },
  {
    label: 'LongTable'
  },
  {
    label: 'Roof'
  }
]
